import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <div className="glass-card github-calendar-card" style={{ width: "100%" }}>
        <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
          Days I <strong className="purple">Code</strong>
        </h1>
        <GitHubCalendar
          username="SoheelGadad"
          blockSize={15}
          blockMargin={5}
          color="#3b82f6"
          fontSize={16}
        />
      </div>
    </Row>
  );
}

export default Github;
